export default {"src":"/_next/static/media/marion.4b10cf1a.svg","height":56,"width":234,"blurWidth":0,"blurHeight":0};